<div class="column gap view-wrapper">
  <div class="column gap" *ngIf="allSecurityDomains.includes(getStorageObject('vertical').domain)">
    <app-announcement-management></app-announcement-management>
  </div>
  <div class="row gap">
    <div class="kpi-holder">
      <div class="row-wrap gap">
        <ng-container *ngFor="let menuItem of menuItems">
          <div *ngIf="menuItem.showOnDashboard" class="dashboard-button">
            <a class="button-link" mat-raised-button (click)="onMenuItemClick(menuItem.path)">
              <div class="column center gap">
                <ion-icon class="button-link-icon" name="{{ menuItem.icon }}"></ion-icon>
                <p>{{ menuItem.text | translate }}</p>
              </div>
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
